import { Popover } from "@headlessui/react";

interface PopMenuProps {
  button: JSX.Element;
  menuItems: { component: JSX.Element; onClick: () => void }[];
}

export function PopMenu({ button, menuItems }: PopMenuProps) {
  return (
    <Popover className="relative">
      {({ close }) => (
        <>
          <Popover.Button className="outline-none">{button}</Popover.Button>

          <Popover.Panel className="absolute z-50 shadow-lg right-1 top-7 border rounded-lg">
            {menuItems.map((item, idx) => (
              <div className="grid grid-cols-1 text-sm min-w-[240px]" key={idx}>
                <span
                  onClick={() => {
                    item.onClick();
                    close();
                  }}
                  className="bg-white hover:bg-gray-100 p-3 cursor-pointer whitespace-normal break-words"
                >
                  {item.component}
                </span>
              </div>
            ))}
          </Popover.Panel>
        </>
      )}
    </Popover>
  );
}
